module.exports = __webpack_public_path__ + "static/media/bg.afdd8150.png";